module.exports = __webpack_public_path__ + "media/images/design/images/dantai/btn_sskouken-92fafc41974c62727e1ca10464dbad80.jpg";